module.exports = __webpack_public_path__ + "img/img_3.d313b9bc.png";